/**
 * Column config for Notification Approval Management.
 * @param {string} tabActive - "1" = Pending, "2" = Scheduled, "3" = History, "4" = Drafts, "5" = Rejected
 * @returns {Array} Column config for TableComp
 */
export const getColumnConfig = (tabActive) => {
  const baseColumns = [
    {
      title: "Title",
      avatar: true,
      filter: "searchTitle",
      width: 296,
    },
    {
      title: "Type",
      filter: "selectCategory",
      dropDown: [
        { name: "General", value: 1 },
        { name: "Alert", value: 2 },
      ],
      width: 133,
    },
    {
      title: "Author",
      filter: "searchRecipients",
      width: 189,
    },
    {
      title: "Alert date",
      filter: "datePickerAlert",
      width: 220,
    },
    {
      title: "Expiry date",
      filter: "datePickerExpiry",
      width: 170,
    },
  ];

  const publishedDateColumn = {
    title: "Published date",
    filter: "datePickerAlert",
    width: 204,
  };

  return tabActive === "3"
    ? [...baseColumns, publishedDateColumn]
    : baseColumns;
};
